module.exports = __webpack_public_path__ + "img/kr-product-title-img-3.7f0cb2a.png";